import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    children:[
      {
        path: '',
        name: 'home',
        meta: {
          navText: '网站首页',
        },
        component: () => import('../views/home/index.vue'),
      },
      {
        path: '/about',
        name: 'about',
        meta: {
          navText: '关于我们',
        },
        component: () => import('../views/about/index.vue'),
      },
      {
        path: '/build',
        name: 'build',
        meta: {
          navText: '网站建设',
        },
        component: () => import('../views/build/index.vue'),
      },
      {
        path: '/app',
        name: 'app',
        meta: {
          navText: '手机应用',
        },
        component: () => import('../views/app/index.vue'),
      },
      {
        path: '/Wx',
        name: 'Wx',
        meta: {
          navText: '微信营销',
        },
        component: () => import('../views/Wx/index.vue'),
      },
      {
        path: '/hardware',
        name: 'hardware',
        meta: {
          navText: '硬件开发',
        },
        component: () => import('../views/hardware/index.vue'),
      },
      {
        path: '/Us',
        name: 'Us',
        meta: {
          navText: '联系我们',
        },
        component: () => import('../views/Us/index.vue'),
      },
    ]
  },
]

const router = new VueRouter({
  // base:'/ucheng/',
  // mode:'hash',
  mode:'history',
  routes
})

export default router
